module.exports = __webpack_public_path__ + "img/certificationPassed.79fb7f6e.svg";